/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import styles from './header.module.scss';
import { HeaderInterface } from './headerTypes';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import AvatarSmall from '../../UI/avatar/avatarSmall';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import Line from '../../UI/line/line';
import { UserInterface } from '../../constants/constants';
import { useDispatch, useSelector } from '../../index';
import { factoryReset } from '../../service/UserData';

const Header: React.FC<HeaderInterface> = ({
  onExit,
  onAdd,
  onLogin,
  onLogo,
  onAvatarClick,
}) => {
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 900 }),
    isTabletOrMobile: useMediaQuery({ maxWidth: 1100 }),
    isMobile: useMediaQuery({ maxWidth: 500 }),
  };
  const userData = useSelector((state) => state.userData.user);
  console.log(userData.admin);
  const isLogin = useSelector((state) => state.userData.isLogin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [nUser, setNUser] = useState<UserInterface>(
    userData || {
      id: 1,
      name: 'Юзер',
      avatar: null,
    }
  );
  const FR = () => {
    navigate('/admin');
  };

  useEffect(() => {
    setNUser(userData);
  }, [userData]);

  const Desktop = () => (
    <div className={styles.shell}>
      <Logo onClick={onLogo} className={styles.logo} />
      {isLogin ? (
        <div className={styles.flexRow}>
          <AvatarSmall
            profileName={nUser.name || 'Пользователь'}
            avatar={typeof nUser.avatar === 'string' ? nUser.avatar : null}
            onExit={onExit}
            onAvatarClick={onAvatarClick}
          />
          <Line width={1} height={32} />
          {userData.admin ? (
            <Button
              ver={BUTTON_VER.primary}
              text="Управление"
              customWidth={250}
              onClick={FR}
              type={BUTTON_TYPE.Button}
            />
          ) : (
            <Button
              ver={BUTTON_VER.primary}
              text="Разместить объявление"
              customWidth={250}
              onClick={onAdd}
              type={BUTTON_TYPE.Button}
            />
          )}
        </div>
      ) : (
        <div className={styles.flexRow}>
          <Button
            ver={BUTTON_VER.secondary}
            text="Вход и регистрация"
            customWidth={217}
            onClick={onLogin}
            type={BUTTON_TYPE.Button}
          />
          {userData.admin ? (
            <Button
              ver={BUTTON_VER.primary}
              text="Полный сброс!!!"
              customWidth={250}
              onClick={onAdd}
              type={BUTTON_TYPE.Button}
            />
          ) : (
            <Button
              ver={BUTTON_VER.primary}
              text="Разместить объявление"
              customWidth={250}
              onClick={onAdd}
              type={BUTTON_TYPE.Button}
            />
          )}
        </div>
      )}
    </div>
  );

  const Mobile = () => (
    <div className={styles.flexColumn}>
      <div className={styles.shell}>
        <Logo onClick={onLogo} className={styles.logo} />
        {isLogin ? (
          <AvatarSmall
            profileName={nUser.name || 'Пользователь'}
            avatar={typeof nUser.avatar === 'string' ? nUser.avatar : null}
            onExit={onExit}
            isMobile={false}
            onAvatarClick={onAvatarClick}
          />
        ) : (
          <Button
            ver={BUTTON_VER.secondary}
            text="Вход и регистрация"
            customWidth={217}
            onClick={onLogin}
            type={BUTTON_TYPE.Button}
          />
        )}
      </div>
      <Button
        ver={BUTTON_VER.primary}
        text="Разместить объявление"
        customWidth={900}
        onClick={onAdd}
        type={BUTTON_TYPE.Button}
      />
    </div>
  );

  return resolution.DesktopOrLaptop ? <Desktop /> : <Mobile />;
};

export default Header;
